export default "__VITE_PUBLIC_ASSET__2dad0911__"